import type { Card } from '../../types';

/** Starter attack (ADR-0015 §5, §15, §19). Common 2×1. Scaling dice: one `≥4`
 * cost die for 5 damage, plus up to three further pool dice (any face) at +2
 * damage each — 5/7/9/11 with 1/2/3/4 dice. The extraCost makes "concentrate vs
 * spread" a real spend decision and breaks the high-block stalemate (§19). */
export const POWER_STRIKE: Card = {
  id: 'power-strike',
  name: 'Power Strike',
  type: 'attack',
  rarity: 'common',
  size: { w: 2, h: 1 },
  cost: [{ kind: 'min', value: 4 }],
  effects: [{ kind: 'damage', amount: 5 }],
  extraCost: {
    predicate: { kind: 'min', value: 1 },
    perDie: [{ kind: 'damage', amount: 2 }],
  },
};
